import React, { useState, useEffect } from "react";
import { Paper } from "@material-ui/core";
import * as S from "../formStyle";
import Select from "react-select";

function DropDownBox({
	title,
	filterName,
	handleInputChange,
	valoresRespostas,
	isLoading,
	valoresOpcoes,
	valueId,
	descricaoComponente,
	ordem,
	conteudoOnChange,
	disabledList,
	componenteWidth,
}) {
	const [textFilter, setTextFilter] = useState("");
	const classes = S.useStyles();

	const returnValoresOpcoes = () => {
		let arrayTemp = [];
		arrayTemp = valoresOpcoes.filter((item) => {
			return item.label.toUpperCase().includes(textFilter);
		});
		return arrayTemp;
	};

	const returnValue = () => {
		let val = {};
		let arrayTemp = [];
		arrayTemp = valoresOpcoes?.filter((item) => {
			return item.value == valoresRespostas[ordem];
		});
		if (arrayTemp.length > 0) {
			val = arrayTemp[0];
		}
		return val;
	};

	const svgIcon =
		'<svg class="MuiSvgIcon-root MuiNativeSelect-icon" focusable="false" viewBox="0 0 24 24" aria-hidden="true"><path d="M7 10l5 5 5-5z"></path>	</svg>';

	useEffect(() => {
		// Change do componente para o layout padrão
		var quantSelects = document.querySelectorAll(
			".react-select__control"
		).length;
		for (let index = 0; index < quantSelects; index++) {
			const pai = document.querySelectorAll(".react-select__control")[index]
      const filho = pai.querySelector(".react-select__indicator-separator");
			if (filho) filho.remove();
      pai.style =
			"border-bottom: 1px solid black !important";
		  pai.style.borderBottomRightRadius = "unset";
		  pai.style.borderBottomLeftRadius = "unset";
      pai.querySelector(".react-select__dropdown-indicator").innerHTML =svgIcon; 
      pai.querySelector(".react-select__single-value").style.color = "#949494";
		}

		
	}, []);

	return (
		<>
			<label className={classes.label}>{title}</label>
			<Paper
				className={classes.medium}
				style={{ width: `${componenteWidth}px` }}
				elevation={0}
			>
				<Select
					options={returnValoresOpcoes()}
					className={classes.input}
					style={{
						paddingLeft: "10px",
						borderBottom: "1px solid black !important",
					}}
					classNamePrefix="react-select"
					disabled={isLoading || disabledList[ordem]}
					name={filterName}
					onChange={(e) => {
						handleInputChange(e, ordem, e.value.toString(), conteudoOnChange);
					}}
					onInputChange={(e) => setTextFilter(e.toUpperCase())}
					value={returnValue()}
				/>
			</Paper>
		</>
	);
}

export default DropDownBox;
